<template>
  <div class="upload-list">
    <div v-if="fileListConfig.showClearAllFilesButton" :style="{width: tableWidth}" class="list-control">
      <el-button @click="clearAllFiles" :disabled="files.length === 0 || this.isLoading" type="primary" size="small">{{fileListConfig.clearAllFilesButtonText}}</el-button>
    </div>
    <table :width="tableWidth">
      <thead>
        <tr>
          <th v-if="fileListConfig.showIndex" style="width:90px;">序号</th>
          <th>名称</th>
          <th v-if="fileListConfig.showFileType" style="width:140px;">类型</th>
          <th v-if="fileListConfig.showFileSize" style="width:140px;">文件大小</th>
          <th>状态</th>
          <th class="row-btn">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(file, idx) in files" :key="file.uid">
          <td v-if="fileListConfig.showIndex" style="width:90px;">{{idx + 1}}</td>
          <td>{{file.name}}</td>
          <td v-if="fileListConfig.showFileType" style="width:140px;">{{file.type}}</td>
          <td v-if="fileListConfig.showFileSize" style="width:140px;">{{file.size | returnFileSize}}</td>
          <td :style="{color: returnStatusColor(file.status)}" style="font-weight:500;">{{file.tipText}}</td>
          <td class="row-btn">
            <el-button :disabled="isLoading" type="text" @click="reloadFile(file)" v-if="file.status === 'fail'">重新上传</el-button>
            <el-button :disabled="isLoading" type="text" @click="deleteFile(file)" v-if="file.status !== 'success'" :class="isLoading?'':'delete-btn'">删除</el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/**
 * 上传文件组件列表
 * 入参：
 *      files: 文件列表, 每个文件包含 {name文件名称, type文件类型, size文件大小, tipText文件提示信息, status文件状态} 等属性。
 *      fileListConfig: 列表配置信息, 详见./index.vue -> FILE_LIST_CONFIG。
 *      isLoading: 用以判断是否有文件正在上传。
 */

export default {
  name: 'JyMultipleUploadList',

  props: {
    files: {
      type: Array,
      default: () => []
    },
    fileListConfig: Object,
    isLoading: Boolean
  },

  data () {
    return {
      status2ColorMap: {
        ready: '#409EFF', // ready for upload
        fail: '#F56C6C', // upload fail
        success: '#67C23A' // upload success
      }
    }
  },

  filters: {
    returnFileSize (number) {
      const unitList = ['字节', 'KB', 'MB', 'GB', 'TB']
      const scale = 1 << 10
      let index = 0

      while (number >= scale) {
        number /= scale
        ++index
      }

      return Number(number.toFixed(2)) + unitList[index]
    }
  },

  computed: {
    tableWidth () {
      let showFileType = this.fileListConfig.showFileType
      let showFileSize = this.fileListConfig.showFileSize
      return (showFileType && showFileSize) ? '80%' : (showFileType || showFileSize) ? '70%' : '60%'
    }
  },

  methods: {
    returnStatusColor (status) {
      return this.status2ColorMap[status]
    },

    reloadFile (file) {
      if (this.isLoading) {
        return
      }
      this.$emit('reload-single-file', file.uid)
    },

    deleteFile (file) {
      if (this.isLoading) {
        return
      }
      this.$emit('delete-single-file', file.uid)
    },

    clearAllFiles () {
      if (this.files.length === 0) return

      if (this.fileListConfig.secondaryConfirmation) {
        this.$confirm(this.fileListConfig.secondaryConfirmationText, '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        })
          .then(() => {
            this.$emit('clear-all-files')
          })
          .catch(ignore => {})
        return
      }

      this.$emit('clear-all-files')
    }
  }
}
</script>

<style lang="less" scoped>
.upload-list {
  margin: 16px 0;
  .list-control {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    padding-right: 0;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
    thead {
      width: calc(100% - 1em)
    }
    tbody {
      display: block;
      height: 195px;
      overflow-y: scroll;
      tr:hover {
        background-color: #f1f1f1;
      }
      .delete-btn {
        color: #f56c6c;
      }
    }
    tr {
      background-color: #fff;
      transition: all .4s ease;
      font-size: 14px;
      color: #333;
      th {
        text-align: left;
        font-weight: 400;
        background: #fafafa;
        border: 1px solid #ebebeb;
        border-width: 0 0 1px;
        padding: 12px 16px;
      }
      td {
        padding: 12px 16px;
      }
      .row-btn {
        width: 180px;
      }
    }
  }
}

table thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/jy-multiple-upload/src/upload-list.vue